export default __webpack_public_path__ + "static/media/score-tdk.992d9c67.png";